import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="disable-context-menu"
export default class extends Controller {
  connect() {
    this.element.addEventListener("contextmenu", this.preventContext);
  }

  disconnect() {
    this.element.removeEventListener("contextmenu", this.preventContext);
  }

  preventContext = (event) => {
    event.preventDefault();
  }
}
